import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { groupBy } from 'utils';

import Dropdown from 'components/DropdownFilter';
import VacancyListBlock from 'components/VacancyListBlock';
import GoToReachMeeProfile from 'components/GoToReachMeeProfile';

import css from './VacanciesFilter.module.scss';

import {THEMES} from 'constants/themes';

class VacanciesFilter extends React.Component {
    static propTypes = {
        regionFilter: PropTypes.string,
        businessAreaFilter: PropTypes.string,
        unitFilter: PropTypes.string,
        jobTypeFilter: PropTypes.string,

        regionsLabel: PropTypes.string.isRequired,
        businessAreasLabel: PropTypes.string.isRequired,
        unitsLabel: PropTypes.string.isRequired,
        jobTypesLabel: PropTypes.string.isRequired,

        regions: PropTypes.array.isRequired,
        businessAreas: PropTypes.array.isRequired,
        units: PropTypes.array.isRequired,
        jobTypes: PropTypes.array.isRequired,
        vacancies: PropTypes.array.isRequired,
        goToReachmeeProfile: PropTypes.shape({
            text: PropTypes.string,
            url: PropTypes.string,
            linkText: PropTypes.string
        })
    }

    constructor(props){
        super(props);

        this.state = {
            regionFilter: props.regionFilter || props.regions[0].key,
            businessAreaFilter: props.businessAreaFilter || "",
            unitFilter: props.unitFilter || "",
            jobTypeFilter: props.jobTypeFilter || ""
        };
    }

    _handleRegionClick = (e, active) => {
        this.setState({ regionFilter: active, businessAreaFilter: "", unitFilter: "", jobTypeFilter: "" });
    }

    _handleBusinessAreaClick = (e, active) => {
        e.preventDefault();

        this.setState({ businessAreaFilter: active, unitFilter: "", jobTypeFilter: "" });
    }

    _handleUnitClick = (e, active) => {
        e.preventDefault();

        this.setState({ businessAreaFilter: "", unitFilter: active, jobTypeFilter: "" });
    }

    _handleJobTypeClick = (e, active) => {
        e.preventDefault();

        this.setState({ businessAreaFilter: "", unitFilter: "", jobTypeFilter: active });
    }

    groupUnits = () => {
        const { businessAreas, units } = this.props;
        return groupBy(units, i => {
            if(i.businessAreas && i.businessAreas.length){
                return i.businessAreas;
            }
            return null;
        }, businessAreas);
    }

    render() {
        const { regionsLabel, regions, businessAreasLabel, businessAreas, unitsLabel, vacancies, goToReachmeeProfile, jobTypesLabel, jobTypes } = this.props;
        const { regionFilter, businessAreaFilter, unitFilter, jobTypeFilter } = this.state;

        const filteredByRegion = vacancies.filter(v => {
            if(v && v.regionId){
                return regionFilter === "" || v.regionId.toString() === regionFilter.toString();
            }
            return false;
        });

        const filteredVacancies = filteredByRegion.filter(v => {
            return (businessAreaFilter === "" && unitFilter === "" && jobTypeFilter === "") ||
                (businessAreaFilter !== "" && v.businessAreaId.toString() === businessAreaFilter) ||
                (unitFilter !== "" && v.unitId.toString() === unitFilter) || 
                (jobTypeFilter !== "" && v.jobTypeId.toString() === jobTypeFilter);
        });

        return (
            <nav className={css.block}>
                <header className={css.header}>
                    <h1>
                        <strong>{filteredByRegion.length}</strong>
                        <Dropdown
                            className={css['dropdown-block']}
                            heading={regionsLabel}
                            items={regions}
                            active={regionFilter}
                            onSelect={this._handleRegionClick}
                        />
                    </h1>
                </header>
                <section className={css.content}>
                    <Dropdown
                        heading={jobTypesLabel}
                        items={jobTypes}
                        active={jobTypeFilter}
                        onSelect={this._handleJobTypeClick} />
                    <Dropdown
                        heading={businessAreasLabel}
                        items={businessAreas}
                        active={businessAreaFilter}
                        onSelect={this._handleBusinessAreaClick} />
                    <Dropdown
                        heading={unitsLabel}
                        items={this.groupUnits()}
                        active={unitFilter}
                        onSelect={this._handleUnitClick} />
                </section>
                <section className={cn(css.list)}>
                    <VacancyListBlock
                        blockId={200}
                        vacancies={filteredVacancies}
                        theme={THEMES.zebra}
                        displayImages={true}
                    />

                    <GoToReachMeeProfile theme={THEMES.zebra} {...goToReachmeeProfile} />
                </section>
            </nav>
        );
    }
}

export default VacanciesFilter;



// WEBPACK FOOTER //
// ./src/components/VacanciesFilter/VacanciesFilter.jsx